import styled from 'styled-components';

const VTB_BranchTableSectionStyle = styled.div`
	--paddingSize: var(--sp3x);

	.table-wrapper {
		overflow: auto hidden;
		-ms-overflow-style: none;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}

		table {
			width: 100%;
			background: var(--secondaryColor1);
			font-size: var(--p);
			border: 1px solid var(--bgCobalt);
		}

		table thead,
		th {
			background-color: var(--bgCobalt) !important;
		}

		table th,
		table tr,
		table td {
			padding: var(--paddingSize) !important;
		}

		table td,
		table th {
			text-align: center;
		}

		table td,
		table th {
			border: 1px solid var(--bgCobalt);
		}

		table thead tr th {
			display: table-cell;
			white-space: nowrap;
			color: var(--primaryColor3);
		}
	}

	@media only screen and (max-width: 767px) {
		--paddingSize: var(--sp1x);

		table thead tr th {
			white-space: normal !important;
		}
	}
`;

export default VTB_BranchTableSectionStyle;
